import React from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import { Link as RouterLink } from "react-router-dom";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://www.mitre.org/">
        MITRE Corporation
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "red",
    },
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    // width: "100%"
  },

  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "red",
    },
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  descriptionFont: {
    color: "white",
  },
  shadedbg: {
    //backgroundColor: "rgba(21, 40, 54, .8)",
    backgroundColor: "rgba(0,0,0,0.5)",
    marginTop: "0px",
  },
}));

export function Home() {
  const classes = useStyles();
  const mip1_location =`${process.env.PUBLIC_URL}/images/logo.png`
  return (
    <React.Fragment>
      <main>
        {/* Hero unit */}
        <div
          className={classes.heroContent}
          style={{
            backgroundImage:`linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.4)),url(${process.env.PUBLIC_URL + '/img/MIP1.jpeg'})`,
            backgroundRepeat: "repeat-y",
            backgroundSize: "100% 100%",
            textShadow: "black 0.1em 0.2em 0.1em",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {" "}
          <Container maxWidth="sm">
            <Typography
              component="h1"
              variant="h2"
              align="center"
              style={{ opacity: 1, color: "#eeeee4" }}
              gutterBottom
            >
              PACT Decision Support
            </Typography>

            <Typography
              variant="h6"
              align="center"
              color="textSecondary"
              style={{
                color: "#eeeee4",
                backgroundSize: "cover",
                backgroundColor: "transparent",
              }}
              paragraph
            >
              This tool is intended as an aid to assist the acquisition
              professional building out their acquisition strategy and
              contracting approach to deliver the most effective operational
              capability.
            </Typography>
            <Typography
              variant="h6"
              align="center"
              color="textSecondary"
              style={{ color: "#eeeee4" }}
              paragraph
            >
              This tool is NOT a replacement for your own critical thinking!
            </Typography>
            <Typography
              variant="h6"
              color="textSecondary"
              align="center"
              style={{ color: "#eeeee4" }}
              paragraph
            >
              You know your challenge the best and this tool will hopefully help
              you consider the range of options in a more deliberative way.
            </Typography>
            <div className={classes.heroButtons}>
              <Grid container spacing={2} justify="center">
                <Grid item>
                  <Button
                    component={RouterLink}
                    to={"/pact-tool"}
                    variant="contained"
                    color="primary"
                  >
                    Begin
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Container>
        </div>
        <Container className={classes.cardGrid} maxWidth="md">
          {/* End hero unit */}
          <Grid container spacing={4}></Grid>
        </Container>
      </main>
      {/* Footer */}
      <footer className={classes.footer}>
        <Typography variant="h6" align="center" gutterBottom></Typography>
        <Typography
          variant="subtitle1"
          align="center"
          color="textSecondary"
          component="p"
        >
          Draft Version
        </Typography>
        <Copyright />
      </footer>
      {/* End footer */}
    </React.Fragment>
  );
}
